'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var searchString = "";
var keyTimeout = void 0;

function nearest(element, el) {
  if (!element) return false;
  return element === el || nearest(element.parentElement, el);
}

var CanopySelect = function (_React$Component) {
  _inherits(CanopySelect, _React$Component);

  function CanopySelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CanopySelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CanopySelect.__proto__ || Object.getPrototypeOf(CanopySelect)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dialogDisplayed: false,
      top: 0,
      focused: false,
      close: function close(e) {
        if (!nearest(e.target, _this.el)) {
          _this.setState({
            dialogDisplayed: false,
            focused: false
          });
        }
      }
    }, _this.displayDialog = function (e) {
      if (_this.disabled()) return;

      _this.setState({
        dialogDisplayed: true
      });
    }, _this.getIndex = function (key) {
      return (0, _lodash.findIndex)(_this.props.options, { key: key });
    }, _this.onKeyDown = function (e) {
      if (_this.disabled()) return;

      var key = e.key || e.which;
      var selectedIndex = _this.state.selectedIndex;

      if (key !== "Tab" && key !== 9) {
        // tab key
        e.preventDefault();
      }

      if (key === "Enter" || key === 13) {
        // enter key
        _this.selectItem(selectedIndex);
      } else if (key === "ArrowUp" || key === 38) {
        // up key
        if (selectedIndex <= 0 || _this.props.options[selectedIndex - 1].disabled) {
          _this.setState({
            dialogDisplayed: true
          });
        } else {
          _this.setState({
            dialogDisplayed: true,
            selectedIndex: selectedIndex - 1
          });
        }
      } else if (key === "ArrowDown" || key === 40) {
        // down key

        if (selectedIndex === _this.props.options.length - 1 || _this.props.options[selectedIndex + 1].disabled) {
          _this.setState({
            dialogDisplayed: true
          });
        } else {
          _this.setState({
            dialogDisplayed: true,
            selectedIndex: selectedIndex + 1
          });
        }
      } else if (key === "Esc" || key === "Escape" || key === 27) {
        // escape key
        _this.setState({
          dialogDisplayed: false
        });
      } else {
        // all other keys
        _this.highlightByText(key);
      }
    }, _this.triggerItemChange = function () {
      if (_this.props.onChange) {
        _this.props.onChange.call(null, _this.props.options[_this.state.selectedIndex].key, _this.props.options[_this.state.selectedIndex], _this.state.selectedIndex);
      }
    }, _this.selectItem = function (index, e) {
      if (_this.disabled()) return;

      setTimeout(function () {
        _this.setState({
          selectedIndex: index,
          focused: true,
          dialogDisplayed: false
        });
        setTimeout(_this.triggerItemChange);
      });
    }, _this.positionDialogAndGetTop = function (options, index, maxHeight) {
      var distanceFromEnd = options.length - index;
      var numVisibleOptions = Math.floor(maxHeight / 36);
      var numSurroundingOptions = Math.floor((numVisibleOptions - 1) / 2);
      var unusedPixels = maxHeight % 36;

      if (index > numSurroundingOptions && distanceFromEnd < numSurroundingOptions + 1) {
        // Bottom 5
        if (options.length < numVisibleOptions) {
          // Dialog doesn't have a scroll
          return -2 + (36 * index * -1 - 10) + "px";
        } else {
          // Dialog has a scroll
          _this.positionDialog(index, maxHeight);
          var start = maxHeight / -2 - 15;
          return start - (numSurroundingOptions - distanceFromEnd) * 36 + "px";
        }
      } else if (index > numSurroundingOptions) {
        // Middle
        _this.positionDialog(index, maxHeight);
        return maxHeight / -2 - 0.0075 * maxHeight;
      } else {
        // Top 5
        return -1 + (36 * index * -1 - 10) + "px";
      }
    }, _this.positionDialog = function (index, maxHeight) {
      setTimeout(function () {
        var menuDialog = _this.el.querySelector(".cp-select__menu");
        if (menuDialog) {
          var dialogHeightImpact = maxHeight / 2 - 8;
          menuDialog.scrollTop = 36 * index - dialogHeightImpact;
        }
      });
    }, _this.focusSelect = function () {
      if (!_this.state.focused) {
        _this.setState({
          focused: true
        });
      }
    }, _this.onBlur = function () {
      _this.setState({
        focused: false,
        dialogDisplayed: false

      }, function () {
        if (_this.props.onBlur) {
          _this.props.onBlur.call(null, _this.props.options[_this.state.selectedIndex].key, _this.props.options[_this.state.selectedIndex], _this.state.selectedIndex);
        }
      });
    }, _this.highlightByText = function (key) {
      searchString += (0, _lodash.isNumber)(key) ? String.fromCharCode(key) : key;
      var i = _this.getIndexFromString(searchString);

      if (i > -1) {
        _this.selectItem(i);
      }

      clearTimeout(keyTimeout);

      keyTimeout = setTimeout(function () {
        searchString = "";
      }, 1000);
    }, _this.getIndexFromString = function (searchString) {
      searchString = searchString.toLowerCase();
      return (0, _lodash.findIndex)(_this.props.options, function (option) {
        return _this.getViewValue(option) !== null ? _this.getViewValue(option).toLowerCase().indexOf(searchString) === 0 : false;
      });
    }, _this.getViewValue = function (option) {
      if (option.value === null || option.value === undefined) return null;
      return option.value || option;
    }, _this.getDialog = function (dialogDisplayed, options) {
      if (dialogDisplayed) {

        var selectedIndex = _this.state.selectedIndex;

        var optionElements = options.map(function (option, index) {
          if (option.separator) {
            return _react2.default.createElement('li', { key: 'separator' + index, className: 'separator' });
          } else {
            var linkStyles = {
              color: option.value !== null ? "" : "rgba(0,0,0,0)",
              backgroundColor: option.disabled ? "#fff" : "",
              cursor: option.disabled ? "default" : ""
            };
            return _react2.default.createElement(
              'li',
              {
                key: option.key,
                className: selectedIndex === index ? '+selected' : '',
                onMouseDown: option.disabled ? _lodash.noop : _this.selectItem.bind(_this, index)
              },
              _react2.default.createElement(
                'a',
                { style: linkStyles, className: '' + (option.disabled ? "cps-color-af" : "") },
                option.value !== null ? option.value : "null"
              )
            );
          }
        });

        setTimeout(function () {
          try {
            _this.el.querySelector('.cp-select__hidden-input').focus();
          } catch (e) {
            // It is okay if the element does not exist anymore
            if (e.message.indexOf('Invariant Violation') === -1) {
              throw new Error(e.message);
            }
          }
        }, 100);

        var maxHeight = _this.props.maxHeight || 400;
        var zIndex = _this.props.zIndex || 1000;
        var dropdownClass = _this.props.dropdownClass;
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'ul',
            { className: 'cp-select__menu cps-dropdown-menu ' + (dropdownClass ? dropdownClass : ''), style: { top: _this.positionDialogAndGetTop(options, selectedIndex, maxHeight), maxHeight: maxHeight + 'px', zIndex: zIndex } },
            optionElements
          )
        );
      }
    }, _this.disabled = function () {
      return !_this.props.options || _this.props.options.length === 0 || _this.props.disabled;
    }, _this.render = function () {
      var _this$props = _this.props,
          _this$props$options = _this$props.options,
          options = _this$props$options === undefined ? [] : _this$props$options,
          selected = _this$props.selected,
          outerClass = _this$props.outerClass,
          selectClass = _this$props.selectClass,
          placeholder = _this$props.placeholder,
          inputClass = _this$props.inputClass;

      var cpSelectClasses = 'cp-select';
      var selectedItem = options[_this.getIndex(selected)];
      var that = _this;

      if (_this.disabled()) cpSelectClasses += ' +disabled';
      if (_this.state.focused) cpSelectClasses += ' +focus';

      return _react2.default.createElement(
        'div',
        { ref: function ref(el) {
            if (el) that.el = el;
          }, className: 'cp-select-outer ' + (outerClass ? outerClass : ''), role: 'select' },
        _react2.default.createElement('input', { className: 'cp-select__hidden-input ' + (inputClass ? inputClass : ''), onFocus: _this.focusSelect, onBlur: _this.onBlur, onKeyDown: _this.onKeyDown }),
        _react2.default.createElement(
          'div',
          { className: cpSelectClasses + ' ' + (selectClass ? selectClass : ''), onClick: _this.displayDialog },
          selectedItem ? _react2.default.createElement(
            'div',
            { className: 'cp-select__selected' },
            selectedItem.value
          ) : _react2.default.createElement(
            'div',
            { className: 'cp-select__selected', style: { color: '#afafaf' } },
            placeholder
          ),
          options.length > 0 && _react2.default.createElement('div', { className: 'cp-select__icon' })
        ),
        _this.getDialog(_this.state.dialogDisplayed, options)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CanopySelect, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.state.close);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.addEventListener('click', this.state.close);
      var index = this.getIndex(this.props.selected);
      this.setState(function () {
        return {
          selectedIndex: index === -1 ? 0 : index
        };
      });
    }
  }]);

  return CanopySelect;
}(_react2.default.Component);

exports.default = CanopySelect;


if (typeof window !== "undefined" && window && !window.CanopySelect) window.CanopySelect = CanopySelect;